import { STATUS_KEY_TO_TYPE_MAP } from "../../../../constants/LicenseManagement.constants";

/**
 * Calculate total number of active filters across all filter types.
 * @param {Array} licenseFilters - Array of license filter objects
 * @param {string} companyFilter - Company search filter
 * @param {Object} dateRangeFilter - Date range filter object
 * @param {string} searchFilter - Search text filter
 * @returns {number} Total count of active filters
 */
export const calculateTotalFilters = (
  licenseFilters,
  companyFilter,
  dateRangeFilter,
  searchFilter,
) => {
  const licenseStatusCount =
    licenseFilters?.reduce(
      (count, filter) =>
        count +
        Object.values(filter).filter((statusValue) => statusValue === true)
          .length,
      0,
    ) || 0;

  const companyCount = companyFilter ? 1 : 0;
  const dateCount =
    dateRangeFilter?.fromDate && dateRangeFilter?.toDate ? 1 : 0;
  const searchCount = searchFilter ? 1 : 0;

  return licenseStatusCount + companyCount + dateCount + searchCount;
};

/**
 * Get formatted license name with type prefix (e.g., "Public Li", "Dupont Li")
 * @param {number} licenseId - License ID to look up
 * @param {Array} licensePermissions - Array of license permission objects
 * @returns {string} Formatted license name with type prefix
 */
export const getLicenseName = (licenseId, licensePermissions) => {
  const license = licensePermissions?.find((l) => l.id === licenseId);
  return license
    ? `${license.licenseType || ""} ${license.name || ""}`.trim()
    : "";
};

/**
 * Collect active status flags from a license filter
 * @param {Object} filter - License filter object
 * @returns {Array} Array of active status objects with key and type
 */
export const getActiveStatuses = (filter) =>
  Object.entries(STATUS_KEY_TO_TYPE_MAP)
    .filter(([key]) => filter[key])
    .map(([key, type]) => ({ key, type }));

/**
 * Format date range for display
 * @param {string} fromDate - Start date
 * @param {string} toDate - End date
 * @param {Function} formatFn - Date formatting function
 * @returns {string} Formatted date range string
 */
export const formatDateRange = (fromDate, toDate, formatFn) =>
  `${formatFn(fromDate)} - ${formatFn(toDate)}`;
